import { map } from '../../Either/dist/effect-Either.esm.js';
import { encode, decode } from '../../internal/Encoding/Base64.esm.js';
import { encode as encode$1, decode as decode$1 } from '../../internal/Encoding/Base64Url.esm.js';
import { encoder, decoder, DecodeExceptionTypeId as DecodeExceptionTypeId$1, DecodeException as DecodeException$1, isDecodeException as isDecodeException$1 } from '../../internal/Encoding/Common.esm.js';
import { encode as encode$2, decode as decode$2 } from '../../internal/Encoding/Hex.esm.js';

/**
 * This module provides encoding & decoding functionality for:
 *
 * - base64 (RFC4648)
 * - base64 (URL)
 * - hex
 *
 * @since 2.0.0
 */

/**
 * Encodes the given value into a base64 (RFC4648) `string`.
 *
 * @category encoding
 * @since 2.0.0
 */
const encodeBase64 = input => typeof input === "string" ? encode(encoder.encode(input)) : encode(input);

/**
 * Decodes a base64 (RFC4648) encoded `string` into a `Uint8Array`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeBase64 = str => decode(str);

/**
 * Decodes a base64 (RFC4648) encoded `string` into a UTF-8 `string`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeBase64String = str => map(decodeBase64(str), _ => decoder.decode(_));

/**
 * Encodes the given value into a base64 (URL) `string`.
 *
 * @category encoding
 * @since 2.0.0
 */
const encodeBase64Url = input => typeof input === "string" ? encode$1(encoder.encode(input)) : encode$1(input);

/**
 * Decodes a base64 (URL) encoded `string` into a `Uint8Array`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeBase64Url = str => decode$1(str);

/**
 * Decodes a base64 (URL) encoded `string` into a UTF-8 `string`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeBase64UrlString = str => map(decodeBase64Url(str), _ => decoder.decode(_));

/**
 * Encodes the given value into a hex `string`.
 *
 * @category encoding
 * @since 2.0.0
 */
const encodeHex = input => typeof input === "string" ? encode$2(encoder.encode(input)) : encode$2(input);

/**
 * Decodes a hex encoded `string` into a `Uint8Array`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeHex = str => decode$2(str);

/**
 * Decodes a hex encoded `string` into a UTF-8 `string`.
 *
 * @category decoding
 * @since 2.0.0
 */
const decodeHexString = str => map(decodeHex(str), _ => decoder.decode(_));

/**
 * @since 2.0.0
 * @category symbols
 */
const DecodeExceptionTypeId = DecodeExceptionTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Represents a checked exception which occurs when decoding fails.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Creates a checked exception which occurs when decoding fails.
 *
 * @since 2.0.0
 * @category errors
 */
const DecodeException = DecodeException$1;

/**
 * Returns `true` if the specified value is an `DecodeException`, `false` otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isDecodeException = isDecodeException$1;

export { DecodeException, DecodeExceptionTypeId, decodeBase64, decodeBase64String, decodeBase64Url, decodeBase64UrlString, decodeHex, decodeHexString, encodeBase64, encodeBase64Url, encodeHex, isDecodeException };
